import {
  Box,
  Button,
  Container,
  Divider,
  MenuItem,
  Select,
  Stack,
  styled,
} from "@mui/material";
import SessionForm from "components/CreateProgramPage/SessionForm";
import { FormContext } from "components/FormContext";
import ProgramSaveAsTemplateModal from "components/ProgramSaveAsTemplateModal";
import SendProgramModal from "components/SendProgramModal";
import TitleHeader from "components/TitleHeader";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setHeaderDetails } from "store/actions/header";
import { getInitialProgram } from "store/actions/program";
import { setPrompt } from "store/actions/prompt";
import { copySession } from "store/actions/sessions";
import { ATTENTION_MESSAGE } from "utils/constants";

const StyledSelect = styled(Select)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  color: "#4F5668",
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  padding: "1px 12px",
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #E0E4EA",
  },
}));
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 600,
  color: "#4F5668",
}));

const StyledSaveSelect = styled(Select)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  color: "#119C83",
  borderRadius: "8px",
  verticalAlign: "middle",
  backgroundColor: "#E4F2E5",
  padding: "0px 12px",
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #119C83",
  },
  ".MuiSelect-select": {
    color: "#119C83",
  },
}));
const StyledSaveMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "14px",
  color: "#111111",
  paddingTop: "10px",
  paddingBottom: "10px",
  "&:hover": {
    backgroundColor: "#E4F2E5",
  },
}));
const CreateSession = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { formikRef, handleSubmit } = useContext(FormContext);
  const [showSaveTemplateModal, setShowSaveTemplateModal] = useState(false);
  const [showSendProgramModal, setShowSendProgramModal] = useState(false);
  const navigate = useNavigate();
  const { type } = useSelector((state) => state.user.userDetails);
  const sessionDetails = useSelector((state) => id ? state.sessions.currentSession : null) || {};
  const isAdmin = type?.toUpperCase() === "ADMIN";
  const isEvocoachTemplate = sessionDetails?.coach_id === "evocoach";
  useEffect(() => {
    dispatch(getInitialProgram());
    const navDetail = {
      isBreadcrumns: true,
      title: "",
      breadcrumsList: [
        {
          title: "Séances",
          link: "/fitness/sessions",
          command: () => {
            dispatch(
              setPrompt({
                isOpen: true,
                message: ATTENTION_MESSAGE,
                primaryBtnHandler: () => {
                  navigate("/fitness/sessions");
                },
                btnAlign: "right",
                primaryBtnColor: "error",
                secondaryBtnText: "Annuler",
              })
            );
          },
        },
        {
          title: "Création de séance",
          link: "",
        },
      ],
    };
    dispatch(setHeaderDetails(navDetail));
  }, []);
  const handleFitnessSaveActions = (event) => {
    if (event.target.value === "SAVE_AS_TEMPLATE") {
      setShowSaveTemplateModal(true);
    } else if (event.target.value === "SAVE_AS_DRAFT") {
      formikRef.current?.setFieldValue("user_id", "");
      formikRef.current?.setFieldValue("status", "Brouillon");
      handleSubmit();
    }
  };
  return (
    <>
      <Container maxWidth="xxl" className="no-bg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="center"
          justifyContent="space-between"
          gap={1}
        >
          <TitleHeader title={type?.toUpperCase() === "ADMIN" ? "Création de template" : "Création de séance"} />
          <Box>
            {id && !sessionDetails?.status ? null : isAdmin ? (
              <Button
                type="submit"
                color="success"
                variant="contained"
                onClick={() => {
                  formikRef.current?.setFieldValue("user_id", "");
                  formikRef.current?.setFieldValue("status", "Modèle");
                  handleSubmit();
                }}
              >
                Sauvegarder le template
              </Button>
            ) : isEvocoachTemplate ? (
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  dispatch(copySession(id)).then((newId) => {
                    if (newId) navigate(`/fitness/sessions/${newId}`);
                  });
                }}
              >
                Dupliquer la template
              </Button>
            ) : (
              <>
                <StyledSaveSelect
                  id="save"
                  value={""}
                  sx={{
                    marginRight: "10px",
                    display:
                      id &&
                        (sessionDetails?.status === "Actif" ||
                          sessionDetails?.status === "Modèle" ||
                          sessionDetails?.status === "Brouillon")
                        ? "none"
                        : "inline-block",
                  }}
                  displayEmpty
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return "Sauvegarder";
                    }
                  }}
                  onChange={handleFitnessSaveActions}
                >
                  <StyledSaveMenuItem value="SAVE_AS_TEMPLATE">
                    En tant que template
                  </StyledSaveMenuItem>
                  <StyledSaveMenuItem value="SAVE_AS_DRAFT">
                    En tant que brouillon
                  </StyledSaveMenuItem>
                </StyledSaveSelect>
                {id && (sessionDetails?.status === "Modèle" || sessionDetails?.status === "Brouillon") && (
                  <Button
                    type="submit"
                    color="success"
                    variant="outlined"
                    sx={{ marginRight: "10px" }}
                    onClick={() => {
                      formikRef.current?.setFieldValue("status", sessionDetails?.status);
                      handleSubmit();
                    }}
                  >
                    Sauvegarder
                  </Button>
                )}
                <Button
                  type="submit"
                  color="success"
                  variant="contained"
                  onClick={() => {
                    if (id && sessionDetails?.status === "Actif") {
                      handleSubmit();
                    } else {
                      setShowSendProgramModal(true);
                    }
                  }}
                >
                  {id && sessionDetails?.status === "Actif"
                    ? "Sauvergarder les modifications"
                    : "Envoyer"}
                </Button>
              </>
            )}
          </Box>
        </Stack>
        <Divider sx={{ margin: "20px 0" }} />
        <SessionForm isIndependentSession={true} isEvocoachTemplate={isEvocoachTemplate} />
      </Container>
      <ProgramSaveAsTemplateModal
        showSaveTemplateModal={showSaveTemplateModal}
        setShowSaveTemplateModal={setShowSaveTemplateModal}
        isIndependentSession={true}
        handleSubmit={() => {
          formikRef.current?.setFieldValue("status", "Modèle");
          handleSubmit();
        }}
      />
      <SendProgramModal
        showSendProgramModal={showSendProgramModal}
        isIndependentSession={true}
        setShowSendProgramModal={setShowSendProgramModal}
        handleDraftSubmit={() => {
          formikRef.current?.setFieldValue("status", "Brouillon");
          setShowSendProgramModal(false);
          handleSubmit();
        }}
      />
    </>
  );
};

export default CreateSession;
